import { LionDrawer } from '../drawer.js';

customElements.define('lion-drawer', LionDrawer);
